export const privacyPolicyData = [
  {
    heading: "",
    content: [
      {
        type: "content",
        value:
          "Fipay.io (“Fipay,” “we,” “us,” or “our”) is committed to protecting your privacy and maintaining your trust. This Privacy Policy explains how we collect, use, share, and protect your personal information when you access our website (the “Site”) and services (the “Services”). By using Fipay.io, you agree to the practices described in this Privacy Policy.",
      },
    ],
  },
  {
    heading: "1. Information We Collect",
    content: [
      {
        type: "list",
        value: [
          "<ul><li><strong>Identifiers:</strong> Name, email address, phone number, date of birth, username, password, and account details.</li>",
          "<li><strong>Financial Information:</strong> Bank account number, routing number, account balances, transaction history, and other financial details.</li>",
          "<li><strong>Government Identifiers:</strong> Social Security number, driver’s license number, or passport number (when required by law or with your consent).</li>",
          "<li><strong>Commercial Information:</strong> Purchase history, product interests, and preferences.</li>",
          "<li><strong>Internet or Electronic Network Activity:</strong> IP address, device type, browser type, operating system, browsing history, and usage data.</li>",
          "<li><strong>Geolocation Data:</strong> Approximate location inferred from your device or IP address.</li>",
          "<li><strong>Communication Data:</strong> Records of customer service interactions, emails, or messages exchanged with our support team.</li>",
          "<li><strong>Inferences:</strong> Preferences, interests, and user behavior patterns derived from your usage data.</li></ul>",
        ],
      },
    ],
  },
  {
    heading: "2. How We Collect Information",
    content: [
      {
        type: "list",
        value: [
          "<ul><li><strong>Directly from You:</strong> When you register an account, verify your identity, complete a transaction, or contact customer support.</li>",
          "<li><strong>Automatically from Your Device:</strong> Through cookies, tracking technologies, and analytics tools when you access the Site or Services.</li>",
          "<li><strong>From Third Parties:</strong></li>",
          "<li  style='margin-left: 10px;'><strong>Financial Institutions:</strong> To process transactions and verify account details.</li>",
          "<li  style='margin-left: 10px;'><strong>Service Providers:</strong> Payment processors, identity verification providers, and analytics platforms.</li>",
          "<li><strong>Publicly Available Sources:</strong> Government records or public databases.</li></ul>",
        ],
      },
    ],
  },
  {
    heading: "3. How We Use Your Information",
    content: [
      {
        type: "list",
        value: [
          "<ul><li><strong>Provide Services:</strong> Facilitate payments, verify your identity, and ensure transaction security.</li>",
          "<li><strong>Improve User Experience:</strong> Customize your experience, personalize content, and optimize our Services.</li>",
          "<li><strong>Communicate with You:</strong> Send service updates, transaction confirmations, and promotional materials (with your consent).</li>",
          "<li><strong>Prevent Fraud and Enhance Security:</strong> Detect, investigate, and prevent fraud, unauthorized access, and other security risks.</li>",
          "<li><strong>Comply with Legal Obligations:</strong> Fulfill legal, regulatory, and compliance requirements.</li>",
          "<li><strong>Business Operations:</strong> Analyze trends, measure performance, and develop new features.</li></ul>",
        ],
      },
    ],
  },
  {
    heading: "4. How We Share Your Information",
    content: [
      {
        type: "list",
        value: [
          "<ul><li><strong>Service Providers:</strong> Third-party vendors, including payment processors, cloud service providers, and analytics partners.</li>",
          "<li><strong>Financial Institutions:</strong> To process transactions and verify account details.</li>",
          "<li><strong>Legal Authorities:</strong> When required by law, regulation, or legal proceedings.</li>",
          "<li><strong>Business Partners:</strong> With your consent or as part of joint offerings.</li>",
          "<li><strong>Corporate Transactions:</strong> In the event of a merger, acquisition, or sale of assets.</li></ul>",
        ],
      },
    ],
  },
  {
    heading: "5. Data Security",
    content: [
      {
        type: "content",
        value:
          "We implement robust security measures to protect your data, including encryption of sensitive data during transmission and storage, access controls and authentication protocols, and regular security audits and vulnerability assessments. However, no method of transmission over the Internet or storage system is completely secure. You are responsible for safeguarding your account credentials.",
      },
    ],
  },
  {
    heading: "6. Your Privacy Rights",
    content: [
      {
        type: "list",
        value: [
          "<ul><li><strong>Right to Access: </strong>Request access to your personal information.</li>",
          "<li><strong>Right to Correction:</strong> Correct inaccurate or incomplete information.</li>",
          "<li><strong>Right to Deletion:</strong> Request deletion of your data under certain circumstances.</li>",
          "<li><strong>Right to Data Portability:</strong> Receive your information in a machine-readable format.</li>",
          "<li><strong>Right to Opt-Out:</strong> Opt out of marketing communications or certain data uses.</li></ul>",
        ].join("</li></li>"),
      },
      {
        type: "content",
        value:
          "To exercise your rights, contact us at [Insert Email Address]. We may need to verify your identity before processing your request.",
      },
    ],
  },
  {
    heading: "7. Cookies and Tracking Technologies",
    content: [
      {
        type: "list",
        value: [
          "Recognize you across sessions.",
          "Understand how you interact with our Services.",
          "Improve functionality and security.",
        ],
      },
      {
        type: "content",
        value:
          "You can adjust your cookie preferences via your browser settings.",
      },
    ],
  },
  {
    heading: "8. Children’s Privacy",
    content: [
      {
        type: "content",
        value:
          "Our Services are not intended for children under 13 years of age. We do not knowingly collect information from children. If we learn that we have collected data from a child without proper consent, we will take steps to delete it.",
      },
    ],
  },
  {
    heading: "9. International Data Transfers",
    content: [
      {
        type: "content",
        value:
          "Your personal information may be transferred to and processed in countries outside your residence, including the United States. We implement appropriate safeguards, such as standard contractual clauses, to protect your data in such transfers.",
      },
    ],
  },
  {
    heading: "10. Third-Party Links",
    content: [
      {
        type: "content",
        value:
          "Our Site may contain links to third-party websites or services. This Privacy Policy does not apply to those third parties. Please review their privacy policies before interacting with them.",
      },
    ],
  },
  {
    heading: "11. Changes to This Privacy Policy",
    content: [
      {
        type: "content",
        value:
          "We may update this Privacy Policy periodically. Changes will be posted on this page, and the “Effective Date” will be updated accordingly. Material changes will be communicated via email or prominent notices on our Site.",
      },
    ],
  },
  {
    heading: "12. Contact Us",
    content: [
      {
        type: "content",
        value:
          "If you have questions or concerns about this Privacy Policy, contact us: Email: info@fipay.io",
      },
    ],
  },
];
